"use client"

import { Ccm19EmbeddingName } from "src/integrations/ccm19/embeddings"
import { CookieSettingsButton } from "src/integrations/lib/CookieSettingsButton"

export type MissingConsentNoticeProps = {
  consentId: Ccm19EmbeddingName
}

export const MissingConsentNotice = ({ consentId }: MissingConsentNoticeProps) => {
  return (
    <div className="relative z-10 flex size-full items-center justify-center rounded-3xl p-12 sm:aspect-video">
      <div className="bg-brand-secondary-lighter flex max-w-sm flex-col gap-4 rounded-2xl bg-white px-4 py-8 text-base shadow-sm">
        <div>{T.format_description(consentId)}</div>
        <CookieSettingsButton />
      </div>
    </div>
  )
}

const T = {
  format_description: (consentId: Ccm19EmbeddingName) => (
    <>
      Um diesen Inhalt ansehen zu können, akzeptiere bitte die Verwendung von Cookies und Tracking-Technologien für{" "}
      <strong>{consentId}</strong>.
    </>
  ),
}
